export default "__VITE_ASSET__BduW9Jlt__"